import { render, staticRenderFns } from "./FmTableNew.vue?vue&type=template&id=5da5de3b&"
import script from "./FmTableNew.vue?vue&type=script&lang=js&"
export * from "./FmTableNew.vue?vue&type=script&lang=js&"
import style0 from "./FmTableNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports